/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagedetailpaidat4Inputs */

const en_ticketpagedetailpaidat4 = /** @type {(inputs: Ticketpagedetailpaidat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid on`)
};

const de_ticketpagedetailpaidat4 = /** @type {(inputs: Ticketpagedetailpaidat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezahlt am`)
};

/**
* | output |
* | --- |
* | "Paid on" |
*
* @param {Ticketpagedetailpaidat4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagedetailpaidat4 = /** @type {((inputs?: Ticketpagedetailpaidat4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagedetailpaidat4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagedetailpaidat4(inputs)
	return de_ticketpagedetailpaidat4(inputs)
});
export { ticketpagedetailpaidat4 as "ticketPageDetailPaidAt" }